/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { ICheckoutClubInfoCollectorViewProps } from './checkout-club-info-collector';
import { DisplayInfo } from './components/display-info';
import { GiftCollector } from './components/gift-collector';
import { MemberCollector } from './components/member-collector';
import { GiftData } from './types/gift-type';
import { MemberData } from './types/member-type';
// import { Submit } from './components/submit';

// COMMENTED OUT SUBMIT COMPONENT BECAUSE I THINK THE CHECKOUT MANAGER
// CREATES A SUBMIT FOR YOU

export namespace CheckoutClubInfoManager {
    export const renderGiftCollector = (props: ICheckoutClubInfoCollectorViewProps) => {

        return (
            <GiftCollector
                resources={props.resources}
                // tslint:disable-next-line: react-this-binding-issue jsx-no-lambda
                onChange={(giftData) => {
                    props.updateData(giftData);
                }}
                allowEdits={props.allowEdits}
                configEndDates={props.app.config.wineClubGiftEndDate}
                configDatePicker={props.app.config.wineClubGiftDatePicker}
                formData={props.collectedInfo as GiftData}
            />
        );
    };

    export const renderMemberCollector = (props: ICheckoutClubInfoCollectorViewProps) => {

        return (
            <MemberCollector
                resources={props.resources}
                // tslint:disable-next-line: react-this-binding-issue jsx-no-lambda
                onChange={(memberData) => {
                    props.updateData(memberData);
                }}
                allowEdits={props.allowEdits}
                formData={props.collectedInfo as MemberData}
            />
        );
    };

    export const renderDisplayOnly = (props: ICheckoutClubInfoCollectorViewProps) => {
        return <DisplayInfo aggregate={props.collectedInfo} isForSelf={props.forMember} resources={props.resources} />;
    };
}

export default (props: ICheckoutClubInfoCollectorViewProps) => {
    const {
        checkoutClubInfoCollector__title
    } = props.resources;

    const {
        forMember,
        displayOnly,
        displayError
    } = props;

    if (displayOnly) {
        return (
            <div className='checkout-step-club-info'>
                <h2 className='checkout-step-club-info-heading'>{checkoutClubInfoCollector__title}</h2>
                {CheckoutClubInfoManager.renderDisplayOnly(props)}
            </div>
        );
    }

    return (
        <div className='checkout-step-club-info'>
            <h2 className='checkout-step-club-info-heading'>{checkoutClubInfoCollector__title}</h2>
            {
                !displayOnly && displayError &&
                <div className='ms-checkout-payment-instrument__error-message'>
                    {displayError}
                </div>
            }
            {!forMember && CheckoutClubInfoManager.renderGiftCollector(props)}
            {forMember && CheckoutClubInfoManager.renderMemberCollector(props)}
        </div>
    );
};
